import { Grid } from '@mui/material';

import { FormAutocompleteField, FormNumberField, FormTextField } from '../../../../../../common';
import { US_STATE_OPTIONS } from '../../../../../../../constants';
import { MEDICAL_DIAGNOSIS_OPTIONS, MEDICAL_DIAGNOSIS_YEAR_BOUNDS } from '../constants';

import type { DiagnosisFieldsProps } from './types';

export default function DiagnosisFields({ formik, disabled, readOnly, saveField }: DiagnosisFieldsProps) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          readOnly={readOnly}
          label="Diagnosis"
          name="diagnosis_name"
          onChange={saveField}
          options={MEDICAL_DIAGNOSIS_OPTIONS}
          placeholder="Select diagnosis"
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4.5}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          readOnly={readOnly}
          label="Provider name"
          name="diagnosis_provider_name"
          onBlur={saveField}
          placeholder="Provider name"
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4.5}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          readOnly={readOnly}
          label="City"
          name="diagnosis_city"
          onBlur={saveField}
          placeholder="Enter city"
          required
        />
      </Grid>
      <Grid item xs={6} sm={3} md={1.5}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          readOnly={readOnly}
          label="State"
          name="diagnosis_state"
          onChange={saveField}
          options={US_STATE_OPTIONS}
          placeholder="State"
          required
        />
      </Grid>
      <Grid item xs={6} sm={3} md={1.5}>
        <FormNumberField
          disabled={disabled}
          formik={formik}
          readOnly={readOnly}
          label="Year"
          max={MEDICAL_DIAGNOSIS_YEAR_BOUNDS.max}
          min={MEDICAL_DIAGNOSIS_YEAR_BOUNDS.min}
          name="diagnosis_year"
          onBlur={saveField}
          placeholder="Year"
          required
        />
      </Grid>
    </Grid>
  );
}
